import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  makeStyles,
  SvgIcon,
  Toolbar
} from '@material-ui/core';
import { Menu as MenuIcon } from 'react-feather';
import { THEMES } from 'src/constants';
import { useCurrentUser } from 'src/store/account/selectors';
import Account from './Account';
import NotificationsMenu from './NotificationsMenu';
import LogoTop from '../../../components/LogoTop';

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    ...(theme.name === THEMES.LIGHT
      ? {
          boxShadow: 'none',
          backgroundColor: theme.palette.primary.main
        }
      : {}),
    ...(theme.name === THEMES.ONE_DARK
      ? {
          backgroundColor: theme.palette.background.default
        }
      : {})
  },
  toolbar: {
    minHeight: 64,
    paddingLeft: theme.spacing(1)
  },
  logo: {
    marginLeft: theme.spacing(1),
    display: 'flex'
  }
}));

function TopBar({ className, onMobileNavOpen, onDesktopNavTouch, ...rest }) {
  const classes = useStyles();
  const currentUser = useCurrentUser();
  const isProviderUser = Boolean(
    currentUser?.groups?.some((group) => group.name === 'provider')
  );
  const isClientUser = Boolean(
    currentUser?.groups?.some((group) => group.name === 'client')
  );

  return (
    <AppBar className={clsx(classes.root, className)} {...rest}>
      <Toolbar className={classes.toolbar}>
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onMobileNavOpen}>
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        </Hidden>
        <Hidden mdDown>
          <IconButton color="inherit" onClick={onDesktopNavTouch}>
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
          <RouterLink className={classes.logo} to="/">
            <LogoTop />
          </RouterLink>
        </Hidden>
        <Box ml={2} flexGrow={1} />
        {!isProviderUser && !isClientUser ? (
          <Box ml={2}>
            <NotificationsMenu />
          </Box>
        ) : null}
        <Box ml={2}>
          <Account />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
  onDesktopNavTouch: PropTypes.func
};

export default TopBar;
